// src/components/Footer.js
import React from 'react';
import colors from '../colors';

function Footer() {
    return (
        <footer style={styles.footer}>
            <p style={styles.text}>
                &copy; {new Date().getFullYear()} Wisemoji. All rights reserved.
            </p>
            <div style={styles.terms}>
                <a href="/terms" style={styles.legalLink}>
                    Terms of Service
                </a>
            </div>

            <div style={styles.privacy}>
                <a href="/privacy" style={styles.legalLink}>
                    Privacy Policy
                </a>
            </div>
        </footer>
    );
}

const styles = {
    footer: {
        padding: '20px',
        backgroundColor: colors.primaryDark,
        textAlign: 'center',
    },
    text: {
        color: colors.textLight,
        margin: 0,
    },
    terms: {
        textAlign: 'center',
        marginTop: '10px',
    },
    privacy: {
        textAlign: 'center',
        marginTop: '10px',
    },
    legalLink: {
        color: colors.textLight,
        margin: '0 5px',
        fontSize: '1.3rem',
        textDecoration: 'underline',
    },
};

export default Footer;